import { SALE_API_URL } from "../../../constants";
import { apiSlice } from "../../../services";
import { IApiRes } from "../../../types/interfaces";

// Request interfaces
export interface IGetStoreOrdersReq {
    store_id: string;
    search?: string;
    sort_by?: string;
    sort_order?: "asc" | "desc";
    start_time?: string;
    end_time?: string;
    page?: number;
    page_size?: number;
    order_status?: string;
    payment_status?: string;
    link_type?: string;
    meal_type?: string;
}

// Order item interface
export interface IOrderItem {
    id: string;
    name: string;
    quantity: number;
    price: string;
    subtotal: string;
    notes?: string;
}

// Order interface
export interface IOrder {
    id: string;
    order_number: string;
    store_id: string;
    customer_name?: string;
    table_number?: string;
    order_status: string; // pending, processing, completed, cancelled
    payment_status?: string; // paid, unpaid
    payment_method?: string; // cash, credit_card, line_pay, etc.
    meal_type?: string; // dine_in, takeout, delivery
    link_type?: string; // eat365, line_pay, credit_card, cash
    currency?: string; // TWD, USD, etc.
    final_price: string;
    items?: IOrderItem[];
    notes?: string;
    created_at: string;
    updated_at: string;
}

// Response interface
export interface IGetStoreOrdersRes extends IApiRes {
    data: {
        orders: IOrder[];
        pagination: {
            page: number;
            page_size: number;
            total_pages: number;
            total_count: number;
        };
    };
}

export const orderApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // Get store orders
        getStoreOrders: builder.query<IGetStoreOrdersRes, IGetStoreOrdersReq>({
            query: (params) => {
                const { store_id, ...queryParams } = params;
                return {
                    url: `${SALE_API_URL}/stores/${store_id}/orders`,
                    method: "GET",
                    params: queryParams,
                };
            },
            providesTags: ["SalesItems"],
        }),
    }),
});

export const { useGetStoreOrdersQuery } = orderApiSlice;
